import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

/**
 * Polling Configuration
 *
 * Dashboard uses polling for data updates. Worker cron collects data
 * every 1 minute, and the dashboard polls every 10 seconds for fresh data.
 *
 * This provides good UX since most price movements happen over minutes,
 * not seconds, and the 10-second polling keeps the UI responsive.
 */
const POLLING_CONFIG = {
  // Default polling interval for all queries
  defaultInterval: 10 * 1000, // 10 seconds

  // Stale time - how long data is considered fresh
  staleTime: 5 * 1000, // 5 seconds

  // Retry configuration
  retryCount: 2,
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchInterval: POLLING_CONFIG.defaultInterval,
      staleTime: POLLING_CONFIG.staleTime,
      retry: POLLING_CONFIG.retryCount,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
